// API.js
export const API = 'https://www.wynemaker.com/api';
// export const API = 'https://www.wynemaker.com/test_api';
// export const API = 'https://test.wynemaker.com/api'
// export const API = `${window.location.protocol}//${window.location.host}/api`;